import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const ATCFullWrap = styled.div`
  background: #fff;

  .supplinkwrap {
    #Modal {
      max-width: 540px !important;
    }
  }

  .upsellwrap {
    #Modal {
      @media (min-width: 768px) and (max-width: 1023px) {
        max-width: 520px !important;
      }
      @media (min-width: 1024px) {
        max-width: 600px !important;
      }
    }

    .modal-nova-header {
      padding-top: 24px;

      @media (min-width: 768px) {
        padding-bottom: 16px;
      }
      @media (min-width: 1024px) {
        padding-bottom: 24px;
      }
    }
  }

  .travelKitWrap {
    .modal-nova {
      z-index: 100000;
    }

    .modal-nova-header {
      @media (max-width: 767px) {
        height: max-content;
        padding-bottom: 16px !important;
      }

      @media (min-width: 768px) {
        padding: 24px !important;
      }

      @media (min-width: 1024px) {
        padding: 40px !important;
      }
    }

    .modal-nova-header + div {
      @media (min-width: 1024px) {
        padding-left: 40px !important;
        padding-right: 40px !important;
      }
    }
  }

  .left {
    text-align: left;
  }

  .variant-button-mobile {
    font-size: 14px !important;
    line-height: 1.4 !important;
  }
`

export const ATCWrap = styled(Flex)`
  flex-direction: row;
  width: 100%;
  max-width: 1400px;
  padding: 40px 16px 0 16px;
  @media (min-width: 360px) {
    padding: 40px 24px 0 24px;
  }
  margin-left: auto;
  margin-right: auto;

  .main-pdp-image {
    max-height: 300px;
  }

  @media (min-width: 768px) {
    padding: 40px 32px 0 32px;
  }

  @media (min-width: 1024px) {
    padding: 90px 24px 30px;
    .main-pdp-image {
      max-height: 516px;
    }
  }
  @media (min-width: 1200px) {
    padding: 90px 0 30px 0;
  }

  .atc-option-label span {
    font-family: ${theme.wild.font.dinamo.bold};
  }
`

export const TitleWrapFlex = styled(Flex)``

export const TitleBadge = styled(Box)`
  text-align: center;
  border-radius: 4px;
  background: #ffe667;
  width: 41px;
  height: 24px;

  p {
    line-height: 25px !important;
  }

  @media (min-width: 1024px) {
    width: 50px;
    height: 30px;
    p {
      line-height: 31px !important;
    }
  }
`

export const TitleAndInfo = styled(Box)`
  .supplink {
    border-bottom: 1px solid #008078;
    margin: 16px 0;
    @media (min-width: 1024px) {
      margin: 16px 0 32px;
    }
  }

  .container-dosage {
    span {
      display: inline-block !important;
    }
  }

  @media (min-width: 1024px) {
    .sticky {
      margin: 0 16px 0 64px;
      max-width: 568px;
      top: 120px;
      z-index: 0;
      @media (min-width: 1440px) {
        margin: 0 0 0 112px;
      }
    }
  }
  @media (min-width: 1170px) {
    padding-left: 0;
  }

  h2 {
    text-align: center;
    @media (min-width: 1024px) {
      text-align: left;
    }
  }

  .link-with-arrow {
    text-transform: none;
  }
`

export const ImageWrap = styled(Box)`
  margin: 0;
  position: relative;
  display: block;
  @media (min-width: 1024px) {
    margin: 0 auto;
    padding-top: 10px;
    .sticky {
      top: 250px;
      z-index: 0;
    }
  }
`

export const IconsBox = styled(Box)`
  padding: 40px 0 40px;
  @media (min-width: 768px) {
    padding: 32px 0;
  }
  @media (min-width: 1024px) {
    padding: 48px 0 40px;
  }
`

export const InfoFlex = styled(Flex)`
  flex-direction: column;
`

export const InfoDesk = styled(Flex)`
  margin: 8px 0 24px;
  justify-content: center;
  gap: 8px;
  @media (min-width: 768px) {
    margin: 8px 0 24px;
  }
  @media (min-width: 1024px) {
    justify-content: flex-start;
    margin: 16px 0 32px;
    text-align: left;
    flex-direction: row;
  }
  align-items: baseline;
`

export const IconsWrap = styled(Flex)`
  flex-direction: row;
  justify-content: center;
  padding: 40px 0;
  align-content: space-between;
  border-top: 1px solid ${theme.wild.color.master.base.alt.secondary};
  @media (min-width: 1024px) {
    padding: 60px 0;
  }

  &.variant {
    @media (min-width: 1024px) {
      display: none;
    }
  }
`

export const Icon = styled(Flex)`
  flex-direction: column;
  display: flex !important;

  &.i0 {
    width: 33%;
    @media (min-width: 1024px) {
      transform: translate(-10%);
    }

    &.Postpartum {
      @media (min-width: 1024px) {
        width: 45%;
      }
    }
  }

  &.i1 {
    width: 37%;
    @media (min-width: 1024px) {
      transform: translate(-3%);
      &.Postpartum {
        width: 33%;
      }
    }
  }

  &.i2 {
    width: 31%;
    @media (min-width: 1024px) {
      transform: translate(10%);
      &.Postpartum {
        transform: translate(0);
        width: 31%;
      }
    }
  }

  > div {
    text-align: center;
    padding: 0 2vw;
    @media (min-width: 500px) {
      padding: 0 8vw;
    }
    @media (min-width: 1024px) {
      padding: 0 2vw;
    }
  }

  img {
    margin: auto;
    width: 60px;
  }

  p {
    font-size: 12px;
    line-height: 15px;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    > div {
      text-align: left;
      padding: 0;
      align-self: center;
    }
  }
`

export const ModalContentImage = styled.div`
  padding: 24px 0;
`
